import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from '@/App.vue'
import { router } from '@/router'
import { installTooltips } from '@/lib/tooltip'

// The dusk/dawn design system, ported verbatim from the prototype.
import '@/assets/styles/tokens.css'
import '@/assets/styles/base.css'
import '@/assets/styles/app.css'
import '@/assets/styles/floor.css'
import '@/assets/styles/rooms.css'
import '@/assets/styles/panels.css'
import '@/assets/styles/tasks.css'
import '@/assets/styles/memory.css'
import '@/assets/styles/calendar.css'
import '@/assets/styles/responsive.css'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.mount('#app')
installTooltips()

// PWA: prod-only so the dev server never fights a stale worker.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {})
  })
}
